export const guibil_api_en = {
  error: {
    title: 'Error Occured!',
    message: 'An error occurred, check your service connections',
  },
};
